import { AuthCallbackController } from './auth-callback-controller';
import { BexSearchController } from './bex-search-controller';
import { BookmarkletController } from './bookmarklet-controller';
import { CookiePolicyController } from 'controllers/cookie-policy-controller';
import { DeeplinkBuilderController } from './deeplink-builder-controller';
import { EntityTermsAndConditionsController } from './entity-terms-and-conditions-controller';
import { FlexDocumentController } from './flex-document-controller';
import { NotFoundController } from './not-found-controller';
import { ErrorController } from './error-controller';
import { HomeController } from './home-controller';
import { PrivacyPolicyController } from './privacy-policy-controller';
import { ProductsController } from './products-controller';
import { ProgramsController } from './programs-controller';
import { JoinProgramController } from './join-program-controller';
import { JoinProgramConfirmationController } from './join-program-confirmation-controller';
import { QuicklinksController } from './quicklinks-controller';
import { SearchController } from './search-controller';
import { SignInController } from './sign-in-controller';
import { SignoutController } from './signout-controller';
import { SignUpController } from './signup-controller';
import { TermsOfUseController } from './terms-of-use.controller';
import { VrboSearchController } from './vrbo-search-controller';
import { ZendeskLoginController } from './zendesk/login-controller';
import { ZendeskLogoutController } from './zendesk/logout-controller';
import { ZendeskSsoController } from './zendesk/sso-controller';
import { SetPasswordController } from './set-password-controller';
import { PzOAuthCallbackController } from './pz-oauth-callback-controller';
import { PartnerPerfController } from './partner-perf-controller';

import wrapWithAccountDataController from 'controllers/wrap-with-account-data-controller';

export const controllers = [
  AuthCallbackController,
  wrapWithAccountDataController(BexSearchController),
  wrapWithAccountDataController(BookmarkletController),
  wrapWithAccountDataController(CookiePolicyController),
  wrapWithAccountDataController(DeeplinkBuilderController),
  wrapWithAccountDataController(EntityTermsAndConditionsController),
  wrapWithAccountDataController(FlexDocumentController),
  wrapWithAccountDataController(HomeController),
  wrapWithAccountDataController(PrivacyPolicyController),
  wrapWithAccountDataController(ProductsController),
  wrapWithAccountDataController(ProgramsController),
  wrapWithAccountDataController(JoinProgramController),
  wrapWithAccountDataController(JoinProgramConfirmationController),
  wrapWithAccountDataController(QuicklinksController),
  wrapWithAccountDataController(SearchController),
  wrapWithAccountDataController(PartnerPerfController),
  SignInController,
  SignoutController,
  SignUpController,
  wrapWithAccountDataController(TermsOfUseController),
  wrapWithAccountDataController(VrboSearchController),
  ZendeskLoginController,
  ZendeskLogoutController,
  ZendeskSsoController,
  ErrorController,
  SetPasswordController,
  PzOAuthCallbackController,
  // 404 error needs to come last as its a catch all route
  wrapWithAccountDataController(NotFoundController),
];
